import sileo from 'sileo';

const ReleaseNotesToDisplay = new sileo.Model('bposeats', 'release-notes');


const actions = {
    fetchReleaseNotesToDisplay(context, data) {
        return ReleaseNotesToDisplay.objects.filter({}, data);
    },

    getReleaseNoteDetails(context, pk) {
        return ReleaseNotesToDisplay.objects.get(pk);
    }
};

export default {
    namespaced: true,
    actions
};
